/**
 * Common styles used across multiple components
 * This helps maintain consistency and reduces code duplication
 */

export const horizontalScrollbarStyles = {
  overflowX: 'auto',
  overflowY: 'hidden',
  '&::-webkit-scrollbar': {
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '4px',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.5)',
    },
  },
};

export const horizontalContainerStyles = {
  display: 'flex',
  gap: 2,
  padding: '8px 0',
  minWidth: 'max-content',
};

export const horizontalCardStyles = {
  flexShrink: 0,
  width: { xs: '100vw', sm: '300px' },
  maxWidth: '300px',
  minWidth: '250px',
};

export const horizontalCardStylesWide = {
  flexShrink: 0,
  width: { xs: '100vw', sm: '400px' },
  maxWidth: '400px',
  minWidth: '300px',
};
